import React from 'react';

function Blog() {
  return (
    <div>
      <svg
        width='80'
        height='80'
        viewBox='0 0 80 80'
        fill='none'
        xmlns='http://www.w3.org/2000/svg'
      >
        <g filter='url(#filter0_i_115_329)'>
          <rect width='80' height='80' rx='40' fill='currentColor' />
          <g clip-path='url(#clip0_115_329)'>
            <path
              d='M42.4286 24.2142H26.6429C25.9988 24.2142 25.3811 24.4701 24.9257 24.9255C24.4702 25.381 24.2144 25.9987 24.2144 26.6428V53.3571C24.2144 54.0012 24.4702 54.6189 24.9257 55.0744C25.3811 55.5298 25.9988 55.7857 26.6429 55.7857H48.5001C49.1442 55.7857 49.7619 55.5298 50.2173 55.0744C50.6728 54.6189 50.9286 54.0012 50.9286 53.3571V42.4285M24.2144 48.5H50.9286M31.5001 30.2857H36.3572M31.5001 36.3571H33.9286'
              stroke='#FEFEFE'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
            <path
              d='M44.8426 41.2287L37.5569 42.5402L38.7712 35.1573L49.044 24.933C49.2698 24.7054 49.5384 24.5247 49.8343 24.4014C50.1303 24.2781 50.4477 24.2147 50.7683 24.2147C51.0889 24.2147 51.4063 24.2781 51.7023 24.4014C51.9982 24.5247 52.2668 24.7054 52.4926 24.933L55.0669 27.5073C55.2945 27.7331 55.4752 28.0017 55.5985 28.2976C55.7218 28.5936 55.7853 28.911 55.7853 29.2316C55.7853 29.5522 55.7218 29.8696 55.5985 30.1656C55.4752 30.4615 55.2945 30.7301 55.0669 30.9559L44.8426 41.2287Z'
              stroke='#FEFEFE'
              stroke-width='1.5'
              stroke-linecap='round'
              stroke-linejoin='round'
            />
          </g>
        </g>
        <defs>
          <filter
            id='filter0_i_115_329'
            x='-4.42632'
            y='-0.737721'
            width='84.4263'
            height='80.7377'
            filterUnits='userSpaceOnUse'
            color-interpolation-filters='sRGB'
          >
            <feFlood flood-opacity='0' result='BackgroundImageFix' />
            <feBlend
              mode='normal'
              in='SourceGraphic'
              in2='BackgroundImageFix'
              result='shape'
            />
            <feColorMatrix
              in='SourceAlpha'
              type='matrix'
              values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
              result='hardAlpha'
            />
            <feOffset dx='-4.42632' dy='-0.737721' />
            <feGaussianBlur stdDeviation='2.21316' />
            <feComposite in2='hardAlpha' operator='arithmetic' k2='-1' k3='1' />
            <feColorMatrix
              type='matrix'
              values='0 0 0 0 0.564706 0 0 0 0 0.564706 0 0 0 0 0.866667 0 0 0 1 0'
            />
            <feBlend
              mode='normal'
              in2='shape'
              result='effect1_innerShadow_115_329'
            />
          </filter>
          <clipPath id='clip0_115_329'>
            <rect
              width='34'
              height='34'
              fill='white'
              transform='translate(23 23)'
            />
          </clipPath>
        </defs>
      </svg>
    </div>
  );
}

export default Blog;
